import React from 'react';
import { Bar } from "react-chartjs-2";



interface BarComponentProps {
  chartData: any; 
  type : 'team' | 'user';
}


const BarComponent: React.FC<BarComponentProps> =   ({ chartData , type }) => {
  return (
    <div className="chart-container">
      <Bar
        data={chartData}
        options={{
          plugins: {
            title: {
              display: true,
              text: type === 'team' ? 'Kudos granted by team' : 'Kudos granted by user',
            },
            legend: {
              display: false
            }
          }
        }}
      />
    </div>
  );
}

export default BarComponent;